import { Order } from '@cemex-core/cmx-api';
import { GroupingLoad } from '@cemex-core/cmx-api/models/grouping/grouping-load';
import { Action } from '@ngrx/store';
import { ValidateResponse } from '@cemex-core/cmx-api/models/validate/validate-res';

export enum GroupingActionTypes {
  LOAD = '[Grouping] Load grouping',
  LOAD_READY = '[Grouping] Load grouping ready',
  CREATE_ODM_ORDER_READY = '[Grouping] create odm order ready',
  UPDATE_LOAD_DATE = '[Grouping] Patch load',
  BULK_UPDATE_LOAD_DATE = '[Grouping] Bulk patch loads',
  UPDATE_COUNTER_OFFERS = '[Grouping] Update counter offers',
  LOAD_COMPLETE = '[Grouping] Load grouping loads complete',
  CREATE_ODM_ORDER_LOAD_COMPLETE = '[Grouping] Create odm order load complete',
  SET_DRAFT_ORDER = '[Grouping] Set draft order',
  SET_VALIDATE_RESPONSE = '[Grouping] Set validate response',
  CREATE_ODM_ORDER_LOAD = '[Grouping] Create odm order load',
  RESET = '[Grouping] Reset',
}

export class GroupingLoadAction implements Action {
  readonly type = GroupingActionTypes.LOAD;

  constructor() {}
}

export class CreateODMOrderLoadAction implements Action {
  readonly type = GroupingActionTypes.CREATE_ODM_ORDER_LOAD;

  constructor() {}
}

export class GroupingLoadReadyAction implements Action {
  readonly type = GroupingActionTypes.LOAD_READY;

  constructor() {}
}

export class CreateODMOrderReadyAction implements Action {
  readonly type = GroupingActionTypes.CREATE_ODM_ORDER_READY;

  constructor() {}
}


export class GroupingUpdateLoadDateAction implements Action {
  readonly type = GroupingActionTypes.UPDATE_LOAD_DATE;

  constructor(public payload: { load: GroupingLoad; newDate: string }) {}
}

export class GroupingBulkUpdateLoadDateAction implements Action {
  readonly type = GroupingActionTypes.BULK_UPDATE_LOAD_DATE;

  constructor(public payload: string) {}
}

export class GroupingUpdateCounterOffersAction implements Action {
  readonly type = GroupingActionTypes.UPDATE_COUNTER_OFFERS;

  constructor(public payload: { load: GroupingLoad; counterOffers: any[] }) {}
}

export class GroupingLoadCompleteAction implements Action {
  readonly type = GroupingActionTypes.LOAD_COMPLETE;

  constructor(public payload: { loads: GroupingLoad[]; draftId: number }) {}
}

export class CreateODMOrderLoadCompleteAction implements Action {
  readonly type = GroupingActionTypes.CREATE_ODM_ORDER_LOAD_COMPLETE;

  constructor(public payload: { loads: any; draftId: number }) {}
}

export class GroupingSetDraftOrderAction implements Action {
  readonly type = GroupingActionTypes.SET_DRAFT_ORDER;

  constructor(public payload: Order | null) {}
}

export class GroupingSetValidateResponseAction implements Action {
  readonly type = GroupingActionTypes.SET_VALIDATE_RESPONSE;

  constructor(public payload: ValidateResponse | null) {}
}

export class GroupingResetAction implements Action {
  readonly type = GroupingActionTypes.RESET;

  constructor() {}
}

export type GroupingActions =
  | GroupingLoadAction
  | CreateODMOrderLoadAction
  | GroupingLoadReadyAction
  | CreateODMOrderReadyAction
  | GroupingLoadCompleteAction
  | CreateODMOrderLoadCompleteAction
  | GroupingUpdateLoadDateAction
  | GroupingBulkUpdateLoadDateAction
  | GroupingUpdateCounterOffersAction
  | GroupingSetDraftOrderAction
  | GroupingSetValidateResponseAction
  | GroupingResetAction;
